import { reflect } from '@effector/reflect'

import { modalOpener } from '@/shared/ui/modal'

import * as model from './model'
import { AccountNotProtectedDialog as View } from './view'

export const AccountNotProtectedDialog = {
    View: reflect({
        view: View,
        bind: {
            onLaterButtonClick: model.laterButtonClicked,
            onChangeAddressButtonClick: model.changeAddressButtonClicked,
            onVerifyAddressButtonClick: model.verifyAddressButtonClicked,
        },
    }),
    model,
}

model.showFx.use(modalOpener(AccountNotProtectedDialog.View))
